import { useController } from 'react-hook-form';

import { Button, Stack } from '@mantine/core';

import { ComponentHelpers } from 'helpers/ComponentHelpers';

import { ComponentOverviewHitSimple } from 'components/component-overview/ComponentOverviewHit.Simple';
import { useComponent } from 'hooks/use-component';

const CompatibleWithProducts = () => {
    const {
        field: { value: products = [], onChange },
    } = useController({ name: 'compatibleWith' });

    if (!products.length) {
        return null;
    }

    return (
        <Stack gap="xs" justify="stretch">
            {products.map((componentId: string) => (
                <CompatibleComponent
                    key={componentId}
                    componentId={componentId}
                    onRemove={(event) => {
                        event.stopPropagation();
                        onChange(products.filter((savedId: string) => savedId !== componentId));
                    }}
                />
            ))}
        </Stack>
    );
};

const CompatibleComponent = ({
    componentId,
    onRemove,
}: {
    componentId: string;
    onRemove?: (event: React.MouseEvent) => void;
}) => {
    const { component } = useComponent(componentId, {
        depth: 0,
    });

    if (!component) return null;

    return (
        <ComponentOverviewHitSimple
            component={component}
            href={ComponentHelpers.urls.view(component.id)}
            rightSide={
                onRemove ? (
                    <Button size="compact-xs" variant="light" ml="auto" onClick={onRemove}>
                        Remove
                    </Button>
                ) : undefined
            }
        />
    );
};

export { CompatibleWithProducts };
